document.addEventListener('DOMContentLoaded', () => {
    const post = document.querySelector('.post');
    const postNavigation = document.querySelector('#postNavigation');

    // Якщо на сторінці немає статті або контейнера для меню - припиняємо роботу
    if (!post || !postNavigation) return;

    const headings = Array.from(post.querySelectorAll('h1, h2, h3, h4, h5, h6'));
    if (headings.length === 0) return;

    // Очищаємо контейнер перед рендером
    postNavigation.innerHTML = '';

    // Шукаємо мінімальний рівень заголовка (наприклад, h2 = 2)
    const minLevel = Math.min(...headings.map(h => parseInt(h.tagName[1], 10)));

    // Отримуємо поточну URL-адресу без хешу (наприклад: /category/article-name/?param=1)
    // Це вирішує проблему з обрізанням адреси при використанні <base href="/">
    const currentUrlPath = window.location.pathname + window.location.search;

    // Масив для зберігання зв'язку: DOM-елемент заголовка -> DOM-елемент посилання в меню
    const navLinks = [];

    // Стилі для вкладених списків та посилань (Redwood: теплі нейтральні тони, плоский дизайн)
    const nestedListClasses = 'ml-3 mt-0.5 space-y-0.5 border-l border-neutral-40';
    const linkClasses =
        'block border-l-2 border-transparent py-1 pl-3 text-xs text-neutral-70 transition-colors hover:text-slate-150';

    // 1. ГЕНЕРАЦІЯ ДЕРЕВА МЕНЮ
    // Стек відстежує поточну ієрархію списків. Корінь - <ol id="postNavigation">,
    // рівень якого умовно minLevel - 1, щоб перший заголовок потрапив у нього напряму.
    const stack = [{ level: minLevel - 1, list: postNavigation }];

    headings.forEach((heading, index) => {
        // Генеруємо ID для заголовка, якщо його немає
        if (!heading.id) heading.id = `toc-heading-${index}`;

        const level = parseInt(heading.tagName[1], 10);
        const headingText = heading.textContent.trim();

        // Закриваємо гілки, які мають рівень >= поточного (повертаємось до предка)
        while (stack.length > 1 && stack[stack.length - 1].level >= level) {
            stack.pop();
        }

        // Відкриваємо нові вкладені <ul>, доки предок не опиниться рівно на level - 1
        while (stack[stack.length - 1].level < level - 1) {
            const parent = stack[stack.length - 1];
            const nested = document.createElement('ul');
            nested.className = nestedListClasses;

            // Вкладаємо новий <ul> всередину останнього <li> предка (щоб отримати дерево).
            // Якщо <li> ще немає (пропуск рівнів на початку), додаємо напряму у предка.
            const lastLi = parent.list.lastElementChild;
            (lastLi && lastLi.tagName === 'LI' ? lastLi : parent.list).appendChild(nested);

            stack.push({ level: parent.level + 1, list: nested });
        }

        const parent = stack[stack.length - 1];

        const li = document.createElement('li');
        const link = document.createElement('a');

        // ФІКС: Додаємо повний шлях перед хешем
        link.href = `${currentUrlPath}#${heading.id}`;
        link.textContent = headingText;
        link.className = linkClasses;

        // 2. ОБРОБКА КЛІКУ ПО МЕНЮ
        link.addEventListener('click', (e) => {
            e.preventDefault();

            // Відступ для "липкого" хедера (змініть значення, якщо хедер вищий/нижчий)
            const stickyHeaderOffset = 100;
            const targetPosition =
                heading.getBoundingClientRect().top + window.scrollY - stickyHeaderOffset;

            // Плавно скролимо сторінку до заголовка
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth',
            });

            // ФІКС: Оновлюємо URL з урахуванням поточного шляху
            history.replaceState(null, null, `${currentUrlPath}#${heading.id}`);
        });

        li.appendChild(link);
        parent.list.appendChild(li);

        // Зберігаємо посилання для подальшого використання у ScrollSpy
        navLinks.push({
            headingElement: heading,
            linkElement: link,
        });
    });

    // 3. БЕЗПЕЧНИЙ SCROLLSPY (Підсвічування активного пункту)
    let isTicking = false;

    const updateActiveMenuItem = () => {
        // Відступ, при якому заголовок вважається "прочитаним" (висота хедера + невеликий буфер)
        const triggerPoint = window.scrollY + 120;

        let activeIndex = 0;

        // Перевіряємо, чи не доскролив користувач до самого низу сторінки
        const isAtBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 50;

        if (isAtBottom) {
            // Якщо ми в самому низу, активним робимо останній заголовок
            activeIndex = navLinks.length - 1;
        } else {
            // Інакше шукаємо заголовок, який зараз на екрані
            for (let i = 0; i < navLinks.length; i++) {
                const headingTop =
                    navLinks[i].headingElement.getBoundingClientRect().top + window.scrollY;
                if (headingTop <= triggerPoint) {
                    activeIndex = i;
                } else {
                    // Оскільки заголовки йдуть по порядку, як тільки знайшли той, що нижче лінії - зупиняємо цикл
                    break;
                }
            }
        }

        // Оновлюємо класи (підсвічуємо активний)
        navLinks.forEach((item, index) => {
            if (index === activeIndex) {
                item.linkElement.classList.remove('border-transparent', 'text-neutral-70');
                item.linkElement.classList.add('border-itez-red', 'text-slate-150');
            } else {
                item.linkElement.classList.add('border-transparent', 'text-neutral-70');
                item.linkElement.classList.remove('border-itez-red', 'text-slate-150');
            }
        });

        isTicking = false;
    };

    // Слухаємо скрол вікна.
    // { passive: true } - це критично важливо! Це каже браузеру: "Ми не будемо блокувати скрол, прокручуй сторінку миттєво".
    window.addEventListener(
        'scroll',
        () => {
            if (!isTicking) {
                // requestAnimationFrame синхронізує виконання коду з частотою оновлення екрану (60 FPS)
                window.requestAnimationFrame(updateActiveMenuItem);
                isTicking = true;
            }
        },
        { passive: true }
    );

    // Запускаємо один раз при завантаженні, щоб підсвітити правильний пункт, якщо сторінка завантажилась не з початку
    updateActiveMenuItem();
});
